<div class="addLooseArticleToOffer" *ngIf="form">
  <div class="addLooseArticleToOffer-search">
    <div class="addLooseArticleToOffer-searchResults">
      <div class="addLooseArticleToOffer-searchResultsContainer">
        <app-table-form [resourceType]="resourceType" [resourceId]="data"
          (rowSelected)="onItemSelected($event)">
        </app-table-form>
      </div>
    </div>
    <div class="addLooseArticleToOffer-searchItemDetails">
      <div *ngIf="selectedLooseArticle" class="itemDetails">
        <div class="itemDetails-image">
          <img [src]="selectedLooseArticle.externalImage" loading="lazy"/>
        </div>
        <div class="itemDetails-description">
          {{ selectedLooseArticle.description }}
        </div>
      </div>
    </div>
  </div>

  <div class="addLooseArticleToOffer-position">
    <form [formGroup]="form" class="form">
      <div class="form-body">
        <div class="form-section">
          <app-form-row
            [label]="['FORMS.POSITION.NUMBER', 'FORMS.POSITION.DESCRIPTION'] | translateControl : form | async">
            <div class="row">
              <div class="col-md-4">
                <app-input [type]="'number'" [mainForm]="form" [controlName]="'number'">
                </app-input>
              </div>
              <div class="col-md-8" *ngIf="form.controls.text">
                <app-input
                  [type]="'text'"
                  [mainForm]="form"
                  [controlName]="'description'"
                  [charCounter]="true"
                  [maxChars]="maxDescriptionLength"
                ></app-input>
              </div>
            </div>
          </app-form-row>

          <div class="collapseArea">
            <div class="collapseArea-trigger" aria-controls="collapseBasic" (click)="isCollapsed = !isCollapsed"
              [attr.aria-expanded]="!isCollapsed" [ngClass]="{'collapseArea-trigger_open': !isCollapsed}">
              <i svgIcon [icon]="'arrow'" [ngClass]="{'_open': !isCollapsed}"></i>
              {{'FORMS.POSITION.TEXT' | translate}}
              <app-tooltip
                [hasTooltip]="true"
                [insideModal]="true"
                [text]="'GENERAL.NO_POSITION_TEXT_XML' | translate"
                class="collapseArea-triggerInfo"
              >
                <span
                  svgIcon
                  [icon]="'info'"
                  [iconSize]="svgIconSizeMod.DEFAULT"
                  class="iconInfo"
                ></span>
              </app-tooltip>
            </div>
            <div [collapse]="isCollapsed" [isAnimated]="true">
              <div class="collapseArea-body" *ngIf="form.controls.positionTemplate">
                <app-dropdown [mainForm]="form" [controlName]="'positionTemplate'"
                  [options]="dropdownData.positionTemplates" [labelKey]="'name'" [valueKey]="'text'">
                </app-dropdown>

                <app-textarea [mainForm]="form" [controlName]="'text'">
                </app-textarea>
              </div>
            </div>
          </div>

          <div class="addLooseArticleToOffer-positionQuantity"
            [ngClass]="{'addLooseArticleToOffer-positionQuantity_open': !isCollapsed}">
            <div class="addLooseArticleToOffer-positionQuantityInner">
              <app-form-row [label]="['FORMS.POSITION.QUANTITY'] | translateControl : form | async">
                <app-input [type]="'number'" [mainForm]="form" [controlName]="'quantity'">
                </app-input>
              </app-form-row>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
